/**
 * Creates a save data structure for binding account parameter with depreciations.
 *
 * @param {Array} data - The array of depreciation objects.
 * @param {string} data[].group - The group to which the depreciation belongs.
 * @param {string} data[].rowName - The name of the depreciation row.
 * @returns {Array} An array of objects representing the save data.
 * @returns {string} saveData[].activity - The activity name (group).
 * @returns {Array} saveData[].theme - The array of depreciation items for the group.
 * @returns {string} saveData[].theme[].name - The name of the depreciation row.
 * @returns {number} saveData[].theme[].quantity - The quantity of the depreciation item (always 1).
 */
export const createSaveDataDepreciation = (data) => {
  const subTheme = {};

  for (const depreciation of data) {
    const activityCode = depreciation.activity.code;

    if (!subTheme[activityCode]) {
      subTheme[activityCode] = [];
    }

    subTheme[activityCode].push({
      name: depreciation.name,
      quantity: 1,
    });
  }

  const saveData = [];

  for (const theme in subTheme) {
    saveData.push({
      activity: theme,
      theme: subTheme[theme],
    });
  }

  return saveData;
};

export const CATEGORY_DEPRECIATION = "depreciation";
